import DateUtil from "@/util/DateUtil.js";

const list = {
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "결제완료일"], list: list.getHead() },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  /**
   * 결재 문서 조회 조건을 설정하기 위함
   */
  getOptions: () => {
    return {
      /**
       * all: 전체 결재문서
       * pending_or_approved: 진행중 또는 승인된 결재문서
       */
      // type: 'all',
      /**
       * 1: temp(임시작성),
       * 2: registered(등록됨),
       * 3: ongoing(진행중),
       * 4: approved(승인됨)
       * 5: rejected(반려됨)*/
      statusIds: [4],
    };
  },

  /**
   * 목록을 불러온 이후 실제 데이터에 값을 저장하기 전에 실행되는 함수 ( this.listAll = response.data 하기 전 )
   * @param response : 목록데이터
   * @param options : 목록데이터를불러올때사용한옵션
   * @returns {Promise<*>}
   */
  prefixFunc: async (vue, response, options) => {
    return response;
  },

  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "발주부서",
        key: "body.stdInfo.section",
      },
      {
        name: "대분류",
        key: "body.공정분류.대분류",
      },
      {
        name: "중분류",
        key: "body.공정분류.중분류",
      },
      {
        name: "소분류",
        key: "body.공정분류.소분류",
      },
      {
        name: "결제완료일",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).stdInfo.section; // 부서명
        case 2:
          return func.getContent(value).공정분류.대분류; // 대분류
        case 3:
          return func.getContent(value).공정분류.중분류; // 중분류
        case 4:
          return func.getContent(value).공정분류.소분류; // 소분류
        case 5:
          return func.getCreatedDate(value.updated_at);
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
